const state = {
  accounts: {
    isLoading: false,
    many: {},
    one: null,
  },
};

export default state;
